import $ from 'jquery';
import { toggleButtonLoader } from '../utils/button-loader';
import { toggleContentLoader } from '../utils/content-loader';
export default class AjaxButton {
    static xhrRequest = null;
    static init($root = $('body')) {
        this.initAjaxRequest($root);
    }
    static initAjaxRequest($root) {
        $root.on('click', '.js__ajax-button', e => {
            const $element = $(e.currentTarget);
            const confirmationRequired = $element.data('confirmation-required');
            const $confirmationModal = $($element.data('confirmation-modal-selector'));
            if (confirmationRequired) {
                const $confirmationButton = $confirmationModal.find('.js__approve-btn');
                // @ts-ignore
                $confirmationModal.modal({
                    onHidden: () => {
                        $confirmationButton.off('click');
                    },
                });
                $confirmationButton.on('click', () => {
                    this.ajaxRequest($element);
                });
                $confirmationModal.modal('show');
            }
            else {
                this.ajaxRequest($element);
            }
        });
    }
    static ajaxRequest($element) {
        const url = $element.data('url');
        const downloadFileAfterSuccessUrl = $element.data('download-file-after-success-url');
        const fileAfterSuccessName = $element.data('file-after-success-name');
        const data = $element.data('data');
        const successRedirectUrl = $element.data('success-redirect-url');
        const method = $element.data('method') || 'GET';
        const $errorMessage = $($element.data('error-message-selector'));
        const $successMessage = $($element.data('success-message-selector'));
        const contentLoadSelector = $element.data('content-load-selector');
        const isFullContentLoader = $element.data('is-full-content-loader');
        if (this.xhrRequest) {
            this.xhrRequest.abort();
            this.xhrRequest = null;
        }
        this.xhrRequest = $.ajax({
            url,
            method,
            data,
            cache: false,
            beforeSend: () => {
                $errorMessage.addClass('d-none');
                toggleButtonLoader($element, true);
                if (isFullContentLoader) {
                    toggleContentLoader($(contentLoadSelector), true);
                }
            },
        })
            .done(response => {
            const hide = $element.data('hide-on-success');
            if (hide) {
                $element.remove();
            }
            const closeModal = $element.data('close-modal-on-success');
            if (closeModal) {
                $element.closest('.modal').modal('hide');
            }
            if ($successMessage.length) {
                $successMessage.removeClass('d-none');
            }
            if (successRedirectUrl) {
                window.location.replace(successRedirectUrl);
            }
            if (contentLoadSelector) {
                const $content = $(contentLoadSelector);
                $content.html(response);
            }
            if (downloadFileAfterSuccessUrl) {
                this.downloadFile(downloadFileAfterSuccessUrl, fileAfterSuccessName);
            }
        })
            .fail(() => {
            if ($errorMessage.length) {
                $errorMessage.removeClass('d-none');
            }
        })
            .always(() => {
            toggleButtonLoader($element, false);
            if (isFullContentLoader) {
                toggleContentLoader($(contentLoadSelector), false);
            }
        });
    }
    static downloadFile(url, fileAfterSuccessName) {
        fetch(url)
            .then(resp => resp.blob())
            .then(blob => {
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = url;
            a.download = fileAfterSuccessName;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
        });
    }
}
